// ============================================================================
// HINDI TRANSLATIONS - BIBLE FACTS
// ============================================================================
// दिलचस्प बाइबिल तथ्य

export const bibleFacts = [
  {
    category: "सांख्यिकी",
    text: "बाइबिल में कुल 31,173 छंद हैं",
    source: "पांडुलिपियों का पाठ्य विश्लेषण"
  },
  {
    category: "भाषाएं",
    text: "बाइबिल का 3000 से अधिक विभिन्न भाषाओं में अनुवाद किया गया है",
    source: "संयुक्त बाइबिल सोसायटी"
  },
  {
    category: "लेखन",
    text: "बाइबिल लगभग 1600 वर्षों में 40 विभिन्न लेखकों द्वारा लिखी गई थी",
    source: "बाइबिल ऐतिहासिक अध्ययन"
  },
  {
    category: "संरचना",
    text: "भजन संहिता 119 सबसे लंबा अध्याय है जिसमें 176 छंद हैं",
    source: "विहित संरचना"
  },
  {
    category: "रिकॉर्ड",
    text: "हिंदी में सबसे छोटा पद है 'यीशु रोया' (यूहन्ना 11:35)",
    source: "पाठ्य विश्लेषण"
  },
  {
    category: "प्रतीकवाद",
    text: "संख्या 7 पूर्णता का प्रतीक है और 735 बार प्रकट होती है",
    source: "बाइबिल संख्यात्मक अध्ययन"
  },
  {
    category: "शब्दावली",
    text: "शब्द 'प्रेम' विभिन्न रूपों में 500 से अधिक बार प्रकट होता है",
    source: "बाइबिल समनुक्रमणिका"
  }
];

export default bibleFacts;
